import { render } from "./group_feed.html?vue&type=template&id=096c7ca6&external"
import script from "./group_feed.js?vue&type=script&lang=js&external"
export * from "./group_feed.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__